// tslint:disable
import { Log } from 'ng2-logger';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import { Dispatch } from 'redux';
import Loading from '../../components/loading/loading';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import DailyUsersReportModal from './daily-visitor-report-modal';
import { Redirect } from 'react-router-dom';
import { ReportService } from '../../api/report-services';
import { Guid } from 'guid-typescript';
import { Confirm } from '../../components/notification/main';
import Tooltip from '../../components/tooltip/main';
import imgAnn from '../../static/images/announcement.svg';

const T = Translator.create();
const _logger = Log.create('Reports Page');
let _common: Common;
const _reportService = new ReportService();

class ReportsPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            query: '',
            isSearchBoxOpen: false,
            row1status: false,
            row2status: false,
            row3status: false,
            row4status: false,
            searchResults: [],
            reports: [
                
                {
                    type: 4,
                    name: T.t('r_general_activity_report'),
                    description: T.t('r_sandart_general_activity_report'),
                    isViewing: false,
                    redirectUrl: 'u/reports/enrollment?templateId=1',
                    reportTemplateGuid: ''
                },
                {
                    type: 4,
                    name: T.t('r_general_activity_report'),
                    description: T.t('r_editable_activity_report'),
                    isViewing: false,
                    redirectUrl: 'u/reports/enrollment?templateId=-1',
                    reportTemplateGuid: ''
                }
            ],
            redirect: false,
            baseRedirectUrl: ''
        };
    }

    toggleReport = (reportName: string) => {
        const updatedReports = this.state.reports.map((report: any) =>
            report.name === reportName ? { ...report, isViewing: !report.isViewing } : report
        );
        this.setState({
            reports: updatedReports
        });
    };

    deleteReportTemplate = async (reportGuid: Guid) => {
        await _reportService.RequestDeleteReportTemplate(reportGuid);
        this.setState({ reports: this.state.reports.filter((report: any) => report.reportTemplateGuid !== reportGuid) });
    };

    deleteReportTemplateOnClick = async (reportGuid: Guid) => {
        Confirm.setConfirm(
            'normal',
            () => {
                this.deleteReportTemplate(reportGuid);
            },
            T.t('r_report_template_delete_info_message'),
            null
        );
    };

    isReportOpen = (name: string): boolean => {
        const report = this.state.reports.find((report: any) => report.name === name);
        return report.isViewing;
    };

    toggleRedirect = (redirectUrl: string) => {
        this.setState({
            redirect: true,
            baseRedirectUrl: redirectUrl
        });
    };

    // type 1 = frequently used reports
    // type 2 = student reports
    // type 3 = course reports
    // type 4 = activity reports
    getReportStyle = (type: number) => {
        switch (type) {
            case 1:
                return {
                    icon: 'star',
                    color: '#e69319',
                    backgroundColor: '#ffe2b8'
                };
            case 2:
                return {
                    icon: 'people',
                    color: '#3d8f6a',
                    backgroundColor: '#39b27b2e'
                };
            case 3:
                return {
                    icon: 'book',
                    color: '#0f598a',
                    backgroundColor: '#0099ff36'
                };
            case 4:
                return {
                    icon: 'view_list',
                    color: '#8a0f0f',
                    backgroundColor: '#fcccc2'
                };
            default:
                break;
        }
    };

    getReportTemplates = async () => {
        const reportData = await _reportService.RequestReportTemplate();
        var data = await reportData.json();
        if (data.length > 0) {
            data.map((item: any) => {
                this.setState({ reports: [...this.state.reports, item] });
            });
        }
    };

    public componentDidMount() {
        this.getReportTemplates();
    }

    render() {
        const filteredReports = this.state.searchResults.length > 0 || this.state.query
    ? this.state.searchResults
    : this.state.reports;
        const firstRowReports =
            this.state.searchResults.length > 0 ? this.state.searchResults : this.state.reports.filter((report: any) => report.type === 1);

        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.baseRedirectUrl} />;
        }
        return (
            <div style={{ height: '100vh', backgroundColor: '#eeede9' }}>
                <div className="student-course">
                    

                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <Loading spinnerId={'getUserHomeMyCourses'} />

                                <div className="d-flex justify-content-between student-course-header pd-top-30">
                                    <div>
                                        <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_menu_report')}</h2>
                                    </div>
                                    <div className="lead-search-bar">
                                        <div className="question-filter p-0">
                                            <div className="options">
                                                <a
                                                    className="ml-3 mr-3"
                                                    onClick={() => this.setState({ isSearchBoxOpen: !this.state.isSearchBoxOpen })}
                                                    style={{ display: this.state.isSearchBoxOpen ? 'none' : 'block' }}
                                                >
                                                    <i className="material-icons mr-2 align-middle">search</i>
                                                    {T.t('r_gen_search')}
                                                </a>
                                            </div>
                                            <div
                                                id="assignment-search"
                                                className={this.state.isSearchBoxOpen ? 'search collapse show' : 'search collapse'}
                                                style={{ position: 'inherit' }}
                                            >
                                                <div className="input-group">
                                                    <div
                                                        data-toggle="collapse"
                                                        className="input-group-prepend collapsed"
                                                        aria-expanded="false"
                                                    >
                                                        <div
                                                            className="input-group-text"
                                                            onClick={() => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    query: '',
                                                                    searchResults: [],
                                                                    isSearchBoxOpen: !this.state.isSearchBoxOpen
                                                                });
                                                            }}
                                                        >
                                                            <i className="material-icons">close</i>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="inlineFormInputGroup"
                                                        placeholder={T.t('r_gen_search')}
                                                        value={this.state.query}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            const regExp = new RegExp(event.target.value, 'i');                                                    
                                                            this.setState({
                                                                query: event.target.value,
                                                                searchResults: event.target.value
                                                                    ? this.state.reports.filter((report: any) => report.name.match(regExp))
                                                                    : this.state.reports
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ul className="student-course-list list-unstyled">
                                    {/* <li style={{ display: this.state.searchResults.length > 0 ? 'none' : 'block' }} key={'reports-row-2'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row2status: !this.state.row2status })}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#39b27b2e'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#3d8f6a'
                                                        }}
                                                    >
                                                        people
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_students_reports')}
                                                    </h5>
                                                    <p>{T.t('r_students_reports')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 align-self-center">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_student')}
                                                </span>
                                            </div>
                                        </div>
                                        <Collapse isOpen={this.state.row2status}>
                                            <div className="row report-row-expanded">
                                                {this.state.reports
                                                    .filter((report: any) => report.type === 2)
                                                    .map((report: any) => {
                                                        const reportStyle = this.getReportStyle(report.type);
                                                        return (
                                                            <div className="col-md-3 report-card-container">
                                                                <div
                                                                    className="report-card-image"
                                                                    style={{
                                                                        backgroundColor: reportStyle!.backgroundColor
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="material-icons report-row-icon"
                                                                        style={{
                                                                            fontSize: '36px',
                                                                            color: reportStyle!.color
                                                                        }}
                                                                    >
                                                                        {reportStyle!.icon}
                                                                    </i>
                                                                </div>
                                                                <a className="lead-tooltip">
                                                                    <h4  className='text-truncate'
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            lineHeight: '28px',
                                                                            textAlign: 'center'
                                                                        }}
                                                                    >
                                                                        {report.name}
                                                                    </h4>
                                                                    <div className="course-tooltip" style={{zIndex: 1000, padding: '0 5px' }}>
                                                                        <span style={{wordBreak:'break-all'}}>
                                                                            {report.name}
                                                                        </span>
                                                                    </div>
                                                                </a>
                                                                <p className="report-card-description">{report.description}</p>
                                                                <a
                                                                    className="report-card-view-link"
                                                                    style={{
                                                                        color: '#0099ff',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                    onClick={() => this.toggleReport(report.name)}
                                                                >
                                                                    {T.t('r_activity_processing_view_report')}
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </Collapse>
                                    </li> */}
                                    {/* <li style={{ display: this.state.searchResults.length > 0 ? 'none' : 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row3status: !this.state.row3status })}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#0099ff36'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#0f598a'
                                                        }}
                                                    >
                                                        book
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_course_reports')}
                                                    </h5>
                                                    <p>{T.t('r_course_reports')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 align-self-center">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_activity_type_Course')}
                                                </span>
                                            </div>
                                        </div>
                                        <Collapse isOpen={this.state.row3status}>
                                            <div className="row report-row-expanded">
                                                {this.state.reports
                                                    .filter((report: any) => report.type === 3)
                                                    .map((report: any) => {
                                                        const reportStyle = this.getReportStyle(report.type);
                                                        return (
                                                            <div className="col-md-3 report-card-container">
                                                                <div
                                                                    className="report-card-image"
                                                                    style={{
                                                                        backgroundColor: reportStyle!.backgroundColor
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="material-icons report-row-icon"
                                                                        style={{
                                                                            fontSize: '36px',
                                                                            color: reportStyle!.color
                                                                        }}
                                                                    >
                                                                        {reportStyle!.icon}
                                                                    </i>
                                                                </div>
                                                                <a className="lead-tooltip">
                                                                    <h4  className='text-truncate'
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            lineHeight: '28px',
                                                                            textAlign: 'center'
                                                                        }}
                                                                    >
                                                                        {report.name}
                                                                    </h4>
                                                                    <div className="course-tooltip" style={{zIndex: 1000, padding: '0 5px' }}>
                                                                        <span style={{wordBreak:'break-all'}}>
                                                                            {report.name}
                                                                        </span>
                                                                    </div>
                                                                </a>

                                                                <p className="report-card-description">{report.description}</p>
                                                                <a
                                                                    className="report-card-view-link"
                                                                    style={{
                                                                        color: '#0099ff',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                    onClick={() => this.toggleReport(report.name)}
                                                                >
                                                                    {T.t('r_activity_processing_view_report')}
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </Collapse>
                                    </li> */}
                                    <li style={{ display:'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onClick={() => this.setState({ row4status: !this.state.row4status })}
                                        >
                                            <div className="col-md-9 align-self-center" style={{ paddingInlineStart: '0px' }}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#fcccc2'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#8a0f0f'
                                                        }}
                                                    >
                                                        view_list
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{ paddingInlineStart: '20px' }}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_gen_reports_activity_reports')}
                                                    </h5>
                                                    <p style={{ textAlign: 'start' }}>{T.t('r_gen_reports_activity_reports')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 align-self-center">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_activity')}
                                                </span>
                                            </div>
                                        </div>
                                            <div className="row report-row-expanded">
                                            {filteredReports.length > 0 ? (
                                                filteredReports.map((report: any) => {
                                                    const reportStyle = this.getReportStyle(report.type);
                                                    return (
                                                        <div className="col-md-3 report-card-container" key={report.termId}>
                                                            <div
                                                                className="report-card-image"
                                                                style={{
                                                                    backgroundColor: reportStyle!.backgroundColor
                                                                }}
                                                            >
                                                                <i
                                                                    className="material-icons report-row-icon"
                                                                    style={{
                                                                        fontSize: '36px',
                                                                        color: reportStyle!.color
                                                                    }}
                                                                >
                                                                    {reportStyle!.icon}
                                                                </i>
                                                            </div>
                                                            <Tooltip data={report.name} position='top' widthValue='100%'>
                                                                <h4
                                                                    className="text-truncate"
                                                                    style={{
                                                                        fontSize: '16px',
                                                                        lineHeight: '28px',
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    {report.name}
                                                                </h4>
                                                            </Tooltip>
                                                            <p className="report-card-description" style={{ minHeight: "35px", textAlign: 'center' }}>
                                                                {report.description}
                                                            </p>
                                                            <div style={{ textAlign: 'center', paddingTop: '10px' }}>
                                                                <a
                                                                    className="lead-tooltip"
                                                                    style={{
                                                                        color: '#0099ff',
                                                                        textDecoration: 'underline',
                                                                        textAlign: 'center'
                                                                    }}
                                                                    onMouseDown={() =>
                                                                        report.redirectUrl
                                                                            ? this.toggleRedirect(report.redirectUrl)
                                                                            : this.toggleReport(report.name)
                                                                    }
                                                                >
                                                                    {T.t('r_activity_processing_view_report')}
                                                                </a>
                                                            </div>
                                                            {report.isCustom ? (
                                                                    <div style={{ textAlign: 'center', paddingTop: '5px' }}>
                                                                        {' '}
                                                                        <a
                                                                            className="lead-tooltip"
                                                                            style={{
                                                                                color: '#0099ff',
                                                                                textDecoration: 'underline',
                                                                                bottom: 0,
                                                                                marginLeft: '-4%',
                                                                                textAlign: 'center'
                                                                            }}
                                                                            onMouseDown={() =>
                                                                                this.deleteReportTemplateOnClick(report.reportTemplateGuid)
                                                                            }
                                                                        >
                                                                            {T.t('r_gen_delete')}
                                                                        </a>
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                                    
                                                    <img src={imgAnn} />
                                                    <h5 id='unsearched' className='d-block'>
                                                        {T.t('r_report_not_found_criter')}
                                                    </h5>
                                                </div>
                                            )}
                                            </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }
    const newProps: any = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        culture: state.login.identitiy.culture
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CReportsPage = connect(mapStateToProps, dispatchProps)(ReportsPage);

export default withRouter(CReportsPage);
